export default (() => {

    function getChargeToken(options) {

        return new Promise((resolve, reject) => {

            function stripeResponseReceived(status, response) {

                if (response.error) {

                    reject({ 
                        data: {
                            message: getGlobalStripeErrorMessage(response.error),
                            errors: stripeCardErrorToFormError(response.error) 
                        } 
                    });

                } else {

                    resolve(response);
                }
            }

            const stripeParams = {
                number:      options.card_details.card_number || '',
                exp_month:   options.card_details.expiry_month || '',
                exp_year:    options.card_details.expiry_year || '',
                cvc:         options.card_details.security_code || '',
                address_zip: options.billing_address.post_code || ''
            };

            Stripe.card.createToken(stripeParams, stripeResponseReceived.bind(this));
        });
    }

    function getGlobalStripeErrorMessage(stripeError) {

        if (stripeError.type === 'invalid_request_error') {

            return 'The details you provided could not be processed.';

        } else if (stripeError.type === 'api_connection_error' || stripeError.type === 'api_error') {

            return 'Our payment processing service is currently unavailable.';

        } else if (stripeError.type === 'rate_limit_error') {

            return 'Our payment processing service is currently too busy to handle this transaction.';
        }
    }

    function stripeCardErrorToFormError(stripeError) {

        if (stripeError.type === 'card_error') {

            if (stripeError.param) {

                return stripeErrorToFieldError(stripeError);
            }
        }
    }

    function stripeErrorToFieldError(stripeError) {

        if (stripeError.param === 'number') {

            return {
                'card_details.card_number': [stripeError.message]
            };

        } else if (stripeError.param === 'exp_year') {

            return {
                'card_details.expiry_year': [stripeError.message]
            };

        } else if (stripeError.param === 'exp_month') {

            return {
                'card_details.expiry_month': [stripeError.message]
            };

        } else if (stripeError.param === 'cvc') {

            return {
                'card_details.security_code': [stripeError.message]
            };
        }
    }

    return {
        getChargeToken
    };

})();


// WEBPACK FOOTER //
// ./services/stripe.js